module.exports = __webpack_public_path__ + "img/date.svg?5244dfb1397e14b3bc950713a78849e5";